export default __webpack_public_path__ + "0020fe05ae328a631e6b6ecfd646867d.png";